/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon16Solid = forwardRef('ArrowDUturnUpLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.753.41a1.125 1.125 0 0 1 1.495 1.68L4.959 4.126H8.75a5.875 5.875 0 0 1 0 11.75h-4.5a1.125 1.125 0 0 1 0-2.25h4.5a3.625 3.625 0 0 0 0-7.25H4.96l2.288 2.034a1.125 1.125 0 1 1-1.495 1.682l-3.66-3.253a2.125 2.125 0 0 1 0-3.176L5.754.409Z" })));
});
